import React, { useState } from 'react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { TermsOfServiceModal } from './TermsOfServiceModal';
import { ContactSupportModal } from './ContactSupportModal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showContact, setShowContact] = useState(false);
  return <>
      <footer className="bg-[#1a0f2e] text-gray-400 py-12 border-t border-white/10" data-id="element-85">
        <div className="container mx-auto px-4 text-center" data-id="element-86">
          <p className="mb-4 text-white font-serif italic text-lg" data-id="element-87">
            From Trauma to Self-Love
          </p>
          <div className="flex justify-center gap-6 text-sm" data-id="element-88">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors" data-id="element-89">
              Privacy Policy
            </button>
            <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors" data-id="element-90">
              Terms of Service
            </button>
            <button onClick={() => setShowContact(true)} className="hover:text-white transition-colors" data-id="element-91">
              Contact Support
            </button>
          </div>
          <p className="mt-8 text-xs opacity-50" data-id="element-92">
            © {new Date().getFullYear()} All rights reserved.
          </p>
        </div>
      </footer>

      <PrivacyPolicyModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} data-id="element-93" />
      <TermsOfServiceModal isOpen={showTerms} onClose={() => setShowTerms(false)} data-id="element-94" />
      <ContactSupportModal isOpen={showContact} onClose={() => setShowContact(false)} data-id="element-95" />
    </>;
}